
export const VALIDATION_MESSAGE = {

    REQUIRED: 'Completá este campo',
    REQUIRED_OPTION: 'Falta elegir una opción',
    REQUIRED_DATE: 'Seleccioná una fecha',
    REQUIRED_SHORT: 'Obligatorio',
    TOO_MANY_RESULTS: 'La búsqueda trae demasiados resultados, agregá o completá algún dato para acotarla.',
    REQUIRE_FILTER: 'Ingresá al menos un dato para buscar.'

}
